import Splide from "@splidejs/splide";
import InnerImageZoom from 'inner-image-zoom';



class MediaGallery extends HTMLElement {
    constructor() {
        super();

        this.generateSplides();
    }

    generateSplides() {
        const previewSplideSelector = this.querySelector(".media-gallery__splide-preview");
        const thumbnailSplideSelector = this.querySelector(".media-gallery__splide-thumbnails");
        if(!previewSplideSelector || !thumbnailSplideSelector) return;

        const thumbnailSplideObject = thumbnailSplideSelector.getAttribute("data-splide");
        const previewSplideObject = previewSplideSelector.getAttribute("data-splide");

        const thumbnailSplideObjectData = thumbnailSplideObject ? JSON.parse(thumbnailSplideObject) : {};
        const previewSplideObjectData = previewSplideObject ? JSON.parse(previewSplideObject) : {};

        const thumbnailSplide = new Splide(".media-gallery__splide-thumbnails", thumbnailSplideObjectData);
        const previewSplide = new Splide(".media-gallery__splide-preview", previewSplideObjectData);

        const previewSplideSlides = previewSplideSelector.querySelectorAll('li.splide__slide');
        previewSplideSlides.forEach((img_slide, index) => {
            let isZoomed = false;
            let isCurrentlyZoomingIn = false;
            const uniqueClass = `zoom-image-${index}`;
            img_slide.classList.add(uniqueClass);
            
            new InnerImageZoom(`.${uniqueClass}`, {
                afterZoomIn: () => {
                    previewSplide.options = { drag: false };
                    isZoomed = true;
                    isCurrentlyZoomingIn = true;
                    
                    setTimeout(() => {
                        isCurrentlyZoomingIn = false;
                    }, 100);
                },
                afterZoomOut: () => {
                    previewSplide.options = { drag: true };
                    isZoomed = false;
                    isCurrentlyZoomingIn = false;
                }
            });
            
            // Add click listener for mobile zoom out when clicking image
            img_slide.addEventListener('click', (e) => {
                // Skip if currently zooming in
                if (isCurrentlyZoomingIn) {
                    return;
                }
                
                if(window.innerWidth < 1024 && isZoomed) {
                    const closeButton = img_slide.querySelector('.iiz__close--visible') as HTMLElement;
                    
                    if (closeButton) {
                        e.preventDefault();
                        e.stopPropagation();
                        closeButton.click();
                    }
                }
            });
        });
    
        previewSplide.sync(thumbnailSplide);
        // const videoSlide = previewSplide.root.querySelector("deferred-media");
        const reference = this;
        previewSplide.on('moved', function(newIndex, oldIndex, destIndex) {
            window.pauseAllMedia();
            const currentSlide = previewSplide.Components.Elements.slides[previewSplide.index];
            const deferredMedia = currentSlide.querySelector('deferred-media');
            if(deferredMedia != null) {
                // SG 20251128 - Load content if not loaded, or play video if already loaded
                if (!deferredMedia.getAttribute('loaded')) {
                    deferredMedia.loadContent(false);
                } else {
                    // SG 20251128 - Video already loaded - play it with promise handling for browser autoplay policies
                    const video = deferredMedia.querySelector('video') as HTMLVideoElement;
                    if (video) {
                        video.play().catch(() => {
                            // Silently handle autoplay rejection - user can tap to play
                        });
                    }
                }
            }
        })
        previewSplide.mount();
        thumbnailSplide.mount();
    }
}


customElements.define("media-gallery", MediaGallery);

